export const PANEL_KEYS = {
  PLACEMENT_TARGET: 'placement-target',
};
